module.exports = (__webpack_require__(0))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./src/dialog.js from dll-reference girder_lib
// module id = 177
// module chunks = 0